/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboBranchConfigBadRequestResponse,
  BboBranchConfigFailureResponseResponse,
  BboBranchConfigForbiddenResponse,
  BboBranchConfigUnauthorizedResponse,
  DiscrepancyTransferConfigResponse,
  GetDiscrepancyTransferConfigV2Params,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * @summary Get transfer config for raising, disputing, settling discrepancies
 */
export const getDiscrepancyTransferConfigV2 = (
  params: GetDiscrepancyTransferConfigV2Params,
  signal?: AbortSignal,
) => {
  return customInstance<DiscrepancyTransferConfigResponse>({
    url: `/BboBranchConfigService/v2/discrepancy-transfer-config`,
    method: 'get',
    params,
    signal,
  });
};

export const getGetDiscrepancyTransferConfigV2QueryKey = (
  params: GetDiscrepancyTransferConfigV2Params,
) => {
  return [
    `/BboBranchConfigService/v2/discrepancy-transfer-config`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetDiscrepancyTransferConfigV2QueryOptions = <
  TData = Awaited<ReturnType<typeof getDiscrepancyTransferConfigV2>>,
  TError = ErrorType<
    | BboBranchConfigBadRequestResponse
    | BboBranchConfigUnauthorizedResponse
    | BboBranchConfigForbiddenResponse
    | BboBranchConfigFailureResponseResponse
  >,
>(
  params: GetDiscrepancyTransferConfigV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDiscrepancyTransferConfigV2>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDiscrepancyTransferConfigV2QueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDiscrepancyTransferConfigV2>>> = ({
    signal,
  }) => getDiscrepancyTransferConfigV2(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDiscrepancyTransferConfigV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDiscrepancyTransferConfigV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof getDiscrepancyTransferConfigV2>>
>;
export type GetDiscrepancyTransferConfigV2QueryError = ErrorType<
  | BboBranchConfigBadRequestResponse
  | BboBranchConfigUnauthorizedResponse
  | BboBranchConfigForbiddenResponse
  | BboBranchConfigFailureResponseResponse
>;

/**
 * @summary Get transfer config for raising, disputing, settling discrepancies
 */
export const useGetDiscrepancyTransferConfigV2 = <
  TData = Awaited<ReturnType<typeof getDiscrepancyTransferConfigV2>>,
  TError = ErrorType<
    | BboBranchConfigBadRequestResponse
    | BboBranchConfigUnauthorizedResponse
    | BboBranchConfigForbiddenResponse
    | BboBranchConfigFailureResponseResponse
  >,
>(
  params: GetDiscrepancyTransferConfigV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDiscrepancyTransferConfigV2>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetDiscrepancyTransferConfigV2QueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
